const CabecalhoSecaoSchema = () => ({
  title: 'Cabeçalho de seção',
  fieldsets: [
    {
      id: 'default',
      title: 'Cabeçalho',
      fields: ['eyebrow', 'title', 'linkText', 'linkHref'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Selo',
      description: 'Opcional. Texto pequeno em caixa alta acima do título.',
    },
    title: { title: 'Título da seção' },
    linkText: {
      title: 'Texto do link à direita do título',
      description:
        'Opcional. Ex.: Veja todos os comunicados. Aparece só com o texto e o endereço preenchidos.',
    },
    linkHref: {
      title: 'Endereço do link',
      description:
        'Página do site (ex.: /noticias/comunicados) ou endereço externo (https://…).',
    },
  },
  required: ['title'],
});

export default CabecalhoSecaoSchema;
